import { useRegister } from "./RegisterContext";
import { useTranslation } from "react-i18next";



export default function AthleteVerification() {
    const {
        formData,
        details,
        verificationData,
        setVerificationData,
    } = useRegister();

    const { t } = useTranslation();

    const age = formData.birthdate
        ? Math.floor(
            (new Date() - new Date(formData.birthdate)) /
            (365.25 * 24 * 60 * 60 * 1000)
        )
        : null;

    const isAmateur = details.level === "Amateur";
    const isMinor = age !== null && age < 18;
    const isProfessional = [
        "Semi-pro",
        "Professionnel",
        "Élite"
    ].includes(details.level);

    const handleFile = (e) => {
        const { name, files } = e.target;

        setVerificationData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };

    const handleChoice = (value) => {
        setVerificationData((prev) => ({
            ...prev,
            hasOwnId: value,
            own_id: null,
            parent_id: null,
        }));
    };

    const getVerificationMessage = () => {
        if (isProfessional) {
            return {
                title:
                    t(
                        "verification.professionalTitle",
                    ),
                text:
                    t(
                        "verification.professionalText",
                    ),
            };
        }

        if (isAmateur && isMinor) {
            return {
                title:
                    t(
                        "verification.minorTitle",
                    ),
                text:
                    t(
                        "verification.minorText",
                    ),
            };
        }

        return {
            title:
                t(
                    "verification.defaultTitle",
                ),
            text:
                t(
                    "verification.defaultText",
                ),
        };
    };

    const message = getVerificationMessage();

    return (
        <div className="verification-wrapper">

            {/* FULL WIDTH MESSAGE */}
            <VerificationInfo
                title={message.title}
                text={message.text}
            />

            {/* CONTENT */}
            <div className="verification-content">

                {isAmateur && isMinor && (
                    <>
                        <label className="register-question">
                            {t("verification.question")}
                        </label>

                        <div className="register-choice-row">
                            <button
                                type="button"
                                className={
                                    verificationData.hasOwnId === true
                                        ? "choice-btn active"
                                        : "choice-btn"
                                }
                                onClick={() => handleChoice(true)}
                            >
                                {t("verification.yes")}
                            </button>

                            <button
                                type="button"
                                className={
                                    verificationData.hasOwnId === false
                                        ? "choice-btn active"
                                        : "choice-btn"
                                }
                                onClick={() => handleChoice(false)}
                            >
                                {t("verification.no")}
                            </button>
                        </div>

                        {verificationData.hasOwnId === true && (
                            <UploadBox
                                label={
                                    t(
                                        "verification.ownId"
                                    )
                                }
                                name="own_id"
                                file={verificationData.own_id}
                                onChange={handleFile}
                            />
                        )}

                        {verificationData.hasOwnId === false && (
                            <UploadBox
                                label={
                                    t(
                                        "verification.parentId"
                                    )
                                }
                                name="parent_id"
                                file={verificationData.parent_id}
                                onChange={handleFile}
                            />
                        )}
                    </>
                )}

                {isAmateur && !isMinor && (
                    <UploadBox
                        label={
                            t(
                                "verification.ownId"
                            )
                        }
                        name="own_id"
                        file={verificationData.own_id}
                        onChange={handleFile}
                    />
                )}

                {isProfessional && (
                    <>
                        <UploadBox
                            label={
                                t(
                                    "verification.ownId"
                                )
                            }
                            name="own_id"
                            file={verificationData.own_id}
                            onChange={handleFile}
                        />

                        <UploadBox
                            label={
                                t(
                                    "verification.professionalCard"
                                )
                            }
                            name="professional_card"
                            file={verificationData.professional_card}
                            onChange={handleFile}
                        />
                    </>
                )}

            </div>

            {/* BOTTOM */}
            <PrivacyNotice />

        </div>
    );
}

function VerificationInfo({ title, text }) {

    const { t } = useTranslation();


    return (
        <div className="verification-info-card">
            <div className="verification-badge">
                {t("verification.badge")}
            </div>

            <h3>{title}</h3>
            <p>{text}</p>
        </div>
    );
}

function PrivacyNotice() {
    const { t } = useTranslation();
    return (
        <div className="verification-privacy">
            {t("verification.privacy")}
        </div>
    );
}

function UploadBox({ label, name, file, onChange }) {
    return (
        <div className="input-wrapper full-width">
            <label className="pdf-upload-label">
                {label}

                <input
                    required
                    type="file"
                    name={name}
                    accept=".pdf,image/*"
                    hidden
                    onChange={onChange}
                />
            </label>

            {file && (
                <div className="pdf-selected">
                    📄 {file.name}
                </div>
            )}
        </div>
    );
}